import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';

class NMR extends ChemComponent {
  	constructor(props) {
		super(props);
		
		var search = {
			ACCOUNT: '',
			FUND_CODE: '',
			DEPARTMENT: '',
			PROGRAM: '',
			CHART_FIELD_1: '',
			CHART_FIELD_2: ''
		};
		
		// initialize nmr list
		var initialNMRList = this.copyNMRList();
		initialNMRList.query.search = this.constructSearch(search);
		
		this.state = {
			renderKey: 1,
			nmrList: initialNMRList,
			search: search,
			searchCount: null
		};
	}
	
	copyNMRList() {
		var nmrListCopy = this.copyObject(nmrList);
		for (var i = 0; i < nmrList.columns.length; i++) {
			if (nmrList.columns[i].Header) {
				nmrListCopy.columns[i].Header = nmrList.columns[i].Header;
			}
			if (nmrList.columns[i].Cell) {
				nmrListCopy.columns[i].Cell = nmrList.columns[i].Cell;
			}
		}
		return nmrListCopy;
	}
	
	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}
	
	onSubmitSearch(event) {
		var newNMRList = this.copyNMRList();
		newNMRList.query.search = this.constructSearch(this.state.search);
		this.mergeState({ 
			nmrList: newNMRList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
	
	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: []
		};		

		if (!this.isEmpty(data.USER_NAME)) search.Children.push({ Attribute: 'USER_NAME', Operator: 'like', StringValue: '%' + data.USER_NAME + '%' });
		if (!this.isEmpty(data.SPEEDTYPE)) search.Children.push({ Attribute: 'SPEEDTYPE', Operator: 'like', StringValue: '%' + data.SPEEDTYPE + '%' });
		if (!this.isEmpty(data.DESCRIPTION)) search.Children.push({ Attribute: 'DESCRIPTION', Operator: 'like', StringValue: '%' + data.DESCRIPTION + '%' });

		// if there are no terms, forget it
		if (search.Children.length === 0) search = null;
		return search;
	}
	
	render() {

		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'NMR',
			columns: exportColumns,
			entity: 'RECHARGES.NMR_CURRENT_SPEEDTYPES_VW',
			search: this.constructSearch(this.state.search),
			order: ['USER_NAME','SPEEDTYPE']
		});			

		return (<>
			<Container fluid>
				<Row>
				  <Col xs={12} style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
					<span style={{ fontSize: '18px', fontWeight: 'bold' }}>NMR Export</span>
					<ChemEdit parent={this} columns={nmrSearch} data={this.state.search} renderKey={this.state.renderKey} 
					  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} onSubmit={(event) => this.onSubmitSearch(event)} {...this.props}>
					  <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
						<Col xs={3} style={{ marginTop: 8}}>
							{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/CSV'} method='POST'>
								{exportData.map((excelFormField, index) => {
									return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to CSV</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/filetype-csv.png'} style={{ paddingLeft: '20px' }} alt="Export to CSV" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={1} style={{ marginTop: 6 }}>
							<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
								{exportData.map((excelFormField, index) => {
									return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
								{exportData.map((pdfFormField, index) => {
									return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={6}>
						  <Button id="update" variant="warning" type="submit" className="float-end">Search</Button>
						</Col>
					  </Form.Group>
					</ChemEdit>
				  </Col>
				</Row>
				<Row>
					<Col>
						<QueryTable renderKey={this.state.renderKey} parent={this} name='CRS_NMR' table={this.state.nmrList}
							onResult={(data) => this.onSearchResult(data)} offsetHeight='185px' />
					</Col>
				</Row>
			</Container>
		</>);
	}
}

const nmrSearch = [
	{ Header: 'User Name', accessor: 'USER_NAME', row: 0, col: 0 },
	{ Header: 'Speedtype', accessor: 'SPEEDTYPE', row: 0, col: 1 },
	{ Header: 'Description', accessor: 'DESCRIPTION', row: 0, col: 2 }
];

const nmrList = {
	query: { entity: 'RECHARGES.NMR_CURRENT_SPEEDTYPES_VW', search: null, order: ['USER_NAME','SPEEDTYPE'] },
	pageSize: 20,
	columns: [
		{ Header: 'User Name', accessor: 'USER_NAME', width: 300 },
		{ Header: 'Speedtype', accessor: 'SPEEDTYPE', width: 125 },
		{ Header: 'Description', accessor: 'DESCRIPTION', width: 500 }
	]
};

const exportColumns = [
	{ Header: 'User Name', accessor: 'USER_NAME', width: 60 },
	{ Header: 'Speedtype', accessor: 'SPEEDTYPE', width: 25 },
	{ Header: 'Description', accessor: 'DESCRIPTION', width: 100 }
];

export default withRouter(NMR);